<template>
  <div class="maladyType">
    <el-card shadow="never">
      <div class="header-flex">
        <h1>病症列表</h1>
        <div class="input-flex">
          <el-input
            placeholder="请输入搜索内容"
            v-model.lazy="keyword"
            prefix-icon="el-icon-search"
            clearable
            class="input"
          ></el-input>
        </div>
      </div>
      <!-- 列表 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        :max-height="scrollHeight"
      >
        <el-table-column prop="id" label="ID"></el-table-column>
        <el-table-column
          prop="illness_dept_cat_name"
          label="病科病科"
        ></el-table-column>
        <el-table-column
          prop="illness_belong_cat_name"
          label="病症病属"
        ></el-table-column>
        <el-table-column prop="name" label="病症病名"></el-table-column>
        <el-table-column prop="definition_desc" label="概述定义">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.definition_desc"></div>
              <div slot="reference">
                {{ scope.row.definition_desc | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="pathogeny_desc" label="病因病机">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.pathogeny_desc"></div>
              <div slot="reference">
                {{ scope.row.pathogeny_desc | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="dialectics_desc" label="分形辩证">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.dialectics_desc"></div>
              <div slot="reference">
                {{ scope.row.dialectics_desc | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="conditioning_scheme_desc" label="调理方案">
          <template slot-scope="scope">
            <el-popover placement="top" width="600" trigger="hover">
              <div v-html="scope.row.conditioning_scheme_desc"></div>
              <div slot="reference">
                {{ scope.row.conditioning_scheme_desc | filterSplit }}
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="is_common" label="是否常见病症">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="点击设置"
              placement="top-start"
            >
              <el-tag
                v-if="scope.row.is_common === 1"
                type="success"
                @click="modifyIsCommon(scope.row.id, 2)"
                >是</el-tag
              >
              <el-tag
                v-else
                type="info"
                @click="modifyIsCommon(scope.row.id, 1)"
                >否</el-tag
              >
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              @click="modifyRow(scope.row, scope.$index, tableData)"
              type="primary"
              size="small"
              >修改</el-button
            >
            <el-button
              @click="deleteRow(scope.row, scope.$index, tableData)"
              type="danger"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { illnessList, setIsCommon, delIllness } from "@/api/malady";
import debounce from "@/utils/debounce";
export default {
  name: "list",
  data() {
    return {
      keyword: "",
      classify: "",
      property: "",
      scrollHeight: 200,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
    };
  },
  created() {
    this.$store.dispatch("fullscreenLoading", true);
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollHeight = document.body.clientHeight - 270;
    });
    this.getData();
  },
  watch: {
    /**
     * 关键字搜索
     * @param {string} val - 关键词
     */
    keyword() {
      debounce(() => {
        this.$store.dispatch("fullscreenLoading", true);
        this.getData();
      }, 800);
    },
  },
  methods: {
    /**
     * 获取病症列表
     */
    getData() {
      illnessList({
        keyword: this.keyword,
        page: this.currentPage,
        limit: this.pageSize,
      }).then((res) => {
        this.total = res.data.total;
        this.tableData = res.data.list;
        this.$store.dispatch("fullscreenLoading", false);
      });
    },
    /**
     * 删除列表项
     * @param {object} row - 选中的列表项
     * @param {number} index - 下标
     * @param {array} tableData - 数据列表
     */
    deleteRow(row, index, tableData) {
      this.$confirm("是否确认删除该项?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delIllness({
          id: row.id,
        }).then((res) => {
          if (res.data === true) {
            this.$message.success("删除成功!");
            tableData.splice(index, 1);
            this.getData();
          } else {
            this.$message.error("删除失败!");
          }
        });
      });
    },
    /**
     * 修改列表项
     * @param {object} row - 选中的列表项
     */
    modifyRow(row) {
      localStorage.setItem("maladyItem", row);
      this.$router.push({
        path: "/maladyAdd",
        query: {
          type: "modify",
          id: row.id,
        },
      });
    },
    /**
     * 修改是否常见
     * @param {number} id - id
     * @param {number} action - 1:常见 2:不常见
     */
    modifyIsCommon(id, action) {
      this.$confirm(
        `是否要将当前状态设置为  ${action == 1 ? "常见" : "不常见"}`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        setIsCommon({
          id,
          action,
        }).then((res) => {
          if (res.data) {
            this.$message.success("设置成功");
            this.getData();
          } else {
            this.$message.error(res.data);
          }
        });
      });
    },
    /**
     * 改变单页数量
     * @param {number} val - 选中的数量值
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
      this.$store.dispatch("fullscreenLoading", true);
    },
    /**
     * 改变当前页面
     * @param {number} val - 选中的页面值
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
      this.$store.dispatch("fullscreenLoading", true);
    },
  },
  filters: {
    /**
     * 内容过滤
     * @param {string} txt
     * @return {string}
     */
    filterSplit(txt) {
      let content = "";
      if (txt.split("").length > 10) {
        for (let i = 0; i < 10; i++) {
          content = content + txt.split("")[i];
        }
        content = content + "...";
      } else {
        content = txt;
      }
      return content;
    },
  },
};
</script>

<style scoped src="./style/index.css"></style>
